import { Fragment, FunctionComponent, useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import CallRestartedModal from '@/modules/RealtimeAttendance/components/CallRestartedModal'
import CallStartedModal from '@/modules/RealtimeAttendance/components/CallStartedModal'
import AttendanceStartedModal from '@/modules/RealtimeAttendance/components/AttendanceStartedModal'
import ScheduledCallStartedModal from '@/modules/RealtimeAttendance/components/ScheduledCallStartedModal'
import AttendanceLate from '@/modules/RealtimeAttendance/components/AttendanceLate'
import RescheduledByMedicModal from '@/modules/RealtimeAttendance/components/RescheduledByMedicModal'
import TokenValidationModal from '@/modules/RealtimeAttendance/components/TokenValidationModal'
import { useCallMonitoringStore } from '@/modules/VideoCall/store/call-monitoring-store'
import { validateRulesToAccessMeetStore } from '@/components/HOCs/ValidateRulesToAccessMeet/store'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { roomPaths } from '@/modules/Attendance/submodules/Room/constants'
import { useCurrentAppointment } from '../hooks/use-current-appointment'
import { useRealtimeAttendanceContext } from '../contexts/RealtimeAttendanceContext'

const RealtimeAttendance: FunctionComponent = () => {
  const history = useHistory()

  const { clinic } = useAuthContext()

  const { getCurrentAppointment } = useCurrentAppointment()
  const { realtimeAttendance } = useRealtimeAttendanceContext()

  const currentCallAppointmentId = useCallMonitoringStore(
    state => state.appointmentId,
  )

  const setIsAbleToAccessMeet = validateRulesToAccessMeetStore(
    store => store.setIsAbleToAccessMeet,
  )

  const handleNavigateToRoom = useCallback(async () => {
    if (clinic?.flag?.NovaSalaDeEspera) {
      if (realtimeAttendance?.nextScheduled?.id) {
        const currentAppointment = await getCurrentAppointment({
          mode: 'scheduled',
          appointmentId: parseInt(realtimeAttendance.nextScheduled.id),
        })

        history.push(
          `${roomPaths.scheduled.basePath}/${currentAppointment?.roomId}/${currentCallAppointmentId}`,
        )

        return
      }

      if (realtimeAttendance?.immediate?.id) {
        const currentAppointment = await getCurrentAppointment({
          mode: 'immediate',
          queueId: realtimeAttendance.immediate.id,
        })

        history.push(
          `${roomPaths.immediate.basePath}/${currentAppointment?.roomId}`,
        )

        return
      }
    }

    if (!currentCallAppointmentId) return history.push('/chamada')
    return history.push(`/chamada?a=${currentCallAppointmentId}`)
  }, [
    clinic?.flag?.NovaSalaDeEspera,
    currentCallAppointmentId,
    getCurrentAppointment,
    history,
    realtimeAttendance?.immediate?.id,
    realtimeAttendance?.nextScheduled?.id,
  ])

  return (
    <Fragment>
      <CallRestartedModal
        hookSuccess={async () => await handleNavigateToRoom()}
      />
      <CallStartedModal
        hookSuccess={async () => await handleNavigateToRoom()}
      />
      <ScheduledCallStartedModal
        hookSuccess={async () => await handleNavigateToRoom()}
      />
      <AttendanceStartedModal />
      <AttendanceLate />
      <RescheduledByMedicModal />
      <TokenValidationModal
        onActionClick={async cb => {
          setIsAbleToAccessMeet(true)
          await handleNavigateToRoom()
          cb()
        }}
      />
    </Fragment>
  )
}

export default RealtimeAttendance
